import { Button } from '#components/atoms/buttons/Button.tsx';
import { isWebAuthnSupported } from '#util/webauthn-support.ts';

type Props = {
  onChoosePasskey: () => void;
  onChooseTOTP: () => void;
};

export function ChooseMFA({ onChoosePasskey, onChooseTOTP }: Props) {
  const webAuthnSupported = isWebAuthnSupported();

  return (
    <>
      <h1 className="h2 mb-16">Protect your account</h1>
      <p className="p-md mb-24">Choose how you want to secure your account.</p>
      <div className="flex flex-col gap-16">
        {webAuthnSupported && <Button onClick={onChoosePasskey}>Use a passkey</Button>}
        <Button variant={webAuthnSupported ? 'secondary' : undefined} onClick={onChooseTOTP}>
          Use an authenticator app
        </Button>
      </div>
    </>
  );
}
